// import React, { version } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./components/home/Home";
import Contact from "./pages/ContactPage";
import AboutUs from "./pages/AboutUs";
import Rooms from "./components/home/Rooms";
import { ErrorPage } from "./components/errorPage";
import { AppLayout } from "./components/appLayout";
import { RoomDetails } from "./pages/RoomDetails";
import RoomBooking from "./pages/RoomBooking";
// import Policy from "./components/home/policy";
import { PolicyPage } from "./pages/PolicyPage";
import { ThankYouTemplate } from "./components/home/ThankYouTemplate";
// import { AdminLogin } from "./components/adminPanel/login";
import Login from "./pages/login";
import { HotelAdmin } from "./pages/adminPages/adminpannel";
import { ProtectedRoute } from "./components/adminPanel/ProtectedRoute";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "about",
        element: <AboutUs />,
      },
      {
        path: "rooms",
        element: <Rooms />,
      },
      {
        path: "rooms/:id",
        element: <RoomDetails />,
      },
      {
        path: "rooms/:id/booking",
        element: <RoomBooking />,
      },
      {
        path: "booking",
        element: <RoomBooking />,
      },
      {
        path: "policy",
        element: <PolicyPage />,
      },
      {
        path: "adminlogin",
        element: <Login />,
      },
      {
        path: "admin",
        element: <Login />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "/:username/hoteladmin",
        element: (
          <ProtectedRoute>
            <HotelAdmin />
          </ProtectedRoute>
        ),
      },
      {
        path: "booking/thankyou",
        element: <ThankYouTemplate />,
      },
      {
        path: "contact/thankyou",
        element: <ThankYouTemplate />,
      },
    ],
  },
]);
// AOS.init({
//   duration: 1200,
//   once: false, // Ensure animations repeat on re-init
// });
export default function App() {
  return (
    <>
      {/* <h1>{ version}</h1> */}

      {/* <Helmet>
        <meta charSet="utf-8" />
        <link rel="canonical" href="http://bgmhotel.com/" />
        <link rel="canonical" href="https://www.bgmhotel.com/" />
        <link rel="canonical" href="https://bgmhotel.com/" />
      </Helmet> */}

      <RouterProvider router={router}></RouterProvider>
    </>
  );
}
